import { Observable } from 'rxjs';
import { Parameter } from '../../../../../@core/interfaces/common/parameter';


export interface ProductCategoryMstParameter extends Parameter {
    searchTerm: number;
    orderBy: string;  
}
export interface ProductCategoryMst {
    id?:number;
    name:string;  
 
    createdBy:number;
    createdDate:Date;
    updatedBy:number;
    updatedDate:Date
    tenantId:any;
    branchId:any;
      
    parameters?: ProductCategoryMstParameter[];
    links?: any;
}

export abstract class ProductCategoryMstData { 
    abstract list(url: string): Observable<ProductCategoryMst[]>;
    abstract create(url: string,data: ProductCategoryMst): Observable<any>;
    abstract update(url: string,data: ProductCategoryMst): Observable<any>;
    abstract delete(url: string): Observable<any>;
}
